// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root___3hO9","icon":"SortAdornment_icon__1bdow","up":"SortAdornment_up__1m6H6","down":"SortAdornment_down__BpIQ3","active":"SortAdornment_active__1bXPr"};